/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Ai_Style_PlaceholderInputs */

const cs_templates_ai_style_placeholder = /** @type {(inputs: Templates_Ai_Style_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referenční šablona…`)
};

const en_templates_ai_style_placeholder = /** @type {(inputs: Templates_Ai_Style_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reference template…`)
};

/**
* | output |
* | --- |
* | "Reference template…" |
*
* @param {Templates_Ai_Style_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_ai_style_placeholder = /** @type {((inputs?: Templates_Ai_Style_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Ai_Style_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_ai_style_placeholder(inputs)
	return cs_templates_ai_style_placeholder(inputs)
});